<footer class="footer_landing">
    <ul class="partner_logo">
      <li>
        <a href="#">
          <img class="img-fluid" src="https://speedcdn.io/assets/radheexch-client/cp_evolution.png" alt="Evolution">
        </a>
      </li>
      <li>
        <a href="#">
          <img class="img-fluid" src="https://speedcdn.io/assets/radheexch-client/cp_ezugi.png" alt="Ezugi">
        </a>
      </li>
      <li>
        <a href="#">
          <img class="img-fluid" src="https://speedcdn.io/assets/radheexch-client/cp_pragmatic-live.png" alt="Pragmatic Live">
        </a>
      </li>
      <li>
        <a href="#">
          <img class="img-fluid" src="https://speedcdn.io/assets/radheexch-client/cp_betgames.png" alt="Betgames">
        </a>
      </li>
      <li>
        <a href="#">
          <img class="img-fluid" src="https://speedcdn.io/assets/radheexch-client/cp_betsoft.png" alt="Betsoft">
        </a>
      </li>
      <li>
        <a href="#">
          <img class="img-fluid" src="https://speedcdn.io/assets/radheexch-client/cp_spribe.png" alt="Spribe">
        </a>
      </li>
      <li>
        <a href="#">
          <img class="img-fluid" src="https://speedcdn.io/assets/radheexch-client/cp_evoplay.png" alt="Evoplay">
        </a>
      </li>
      <li>
        <a href="#">
          <img class="img-fluid" src="https://images.staticcontent.io/casino/banner/loginimages/logo-18plus.svg" alt="+18">
        </a>
      </li>
    </ul>
    <p>
      {{env.host.name}} is a trading name of Fortune Gaming B.V., registered in Curaçao (Company No. 149672), with its registered office at 19-23 Scharlooweg, Willemstad, Curaçao.  
Licensed under Curaçao N.V. License No: B2C-669UN7GS-2678JAZ.  
Powered by 1xbetfair.  
🔞 Strictly for users 18+ only
    </p>
    <!-- <p>You must be over 18 years old, or the legal age at which gambling or gaming activities are allowed under the law or jurisdiction that applies to you. You must reside in a country in which access to online gambling to its residents.</p> -->
  </footer>
<footer class="container-fluid footer">
  <div class="row">
      <div class="col-12 col-sm-12 col-md-12">
          <app-upcoming></app-upcoming>
      </div>
  </div>
</footer>

<div class="footer-menu">
    <div class="wrapper">
        <div class="button-f" [routerLink]="isLogin() ? ['/dashboard'] : ['/home']" routerLinkActive="active">
            <div class="icon"><img src="https://speedcdn.io/assets/radheexch-client/icons/home.svg" alt=""></div><span>Home</span></div>
        <div class="button-f" routerLink="/inplay" routerLinkActive="active">
            <div class="icon"><img src="https://speedcdn.io/assets/radheexch-client/icons/inplay.svg" alt=""></div><span>Inplay</span></div>
        <div class="button-f" [routerLink]="['/casino', 99999]" routerLinkActive="active">
            <div class="icon"><img src="https://speedcdn.io/assets/radheexch-client/icons/mini_games.gif" alt=""></div><span>MiniGame</span></div>
        <div class="button-f" (click)="isLogin() ? openRightBar() : openLogin(); ">
            <div class="icon"><img src="https://speedcdn.io/assets/radheexch-client/icons/menu.svg" alt=""></div><span>Menu</span></div>
    </div>
  </div>
  
<!-- Right bar overlay-->
<div class="leftbar-overlay"></div>